"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _actions = require("./actions");

var _handleActions;

var initialState = (0, _immutable.Map)();

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchUserSettingActionTypes.SUCCESS, function (state, action) {
  var namespace = action.payload.data.namespace;
  var settings = (0, _immutable.fromJS)(JSON.parse(action.payload.data.value));
  return state.set(namespace, settings);
}), (0, _defineProperty2.default)(_handleActions, _actions.BulkGetUserSettingsActionTypes.SUCCESS, function (state, action) {
  var attributes = action.payload.data.attributes;
  var updatedSettings = attributes.reduce(function (acc, setting) {
    return acc.set(setting.key, setting.value);
  }, (0, _immutable.Map)());
  return state.merge(updatedSettings);
}), (0, _defineProperty2.default)(_handleActions, _actions.SaveUserSettingActionTypes.SUCCESS, function (state, action) {
  var _action$payload$data = action.payload.data,
      key = _action$payload$data.key,
      value = _action$payload$data.value;
  return state.set(key, value);
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;